import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import MediaQuery from 'react-responsive';
import Select from "react-dropdown-select";
import ReactGA from 'react-ga';

import CPUImg2x from '../../../assets/img/cpu@2x.png';
import PlatformImg2x from '../../../assets/img/platform@2x.png';
import BusinessImg2x from '../../../assets/img/business@2x.png';
import ExpertImg2x from '../../../assets/img/expert@2x.png';

import CpuPath from './CpuPath';
import PlatformPath from './PlatformPath';
import BizPath from './BizPath';
import RequestModal from '../../RequestModal';

import styles from './ConfigureOwnScreen.module.css';
import { ASK_AN_EXPERT_LANGING_MIDDLE } from '../../../utils/constants';

const ConfigureOwnScreen = (props) => {
  const { showModal } = props;
  const { formatMessage } = useIntl();

  const [ selectedPath, setSelectedpath ] = useState('cpu');
  const selectOptions = [
    {
      label: formatMessage({id: 'ConfigureOwn.CPUOptionTitle'}),
      value: 'cpu',
    },
    {
      label: formatMessage({id: 'ConfigureOwn.PlatformOptionTitle'}),
      value: 'platform',
    },
    {
      label: formatMessage({id: 'ConfigureOwn.BusinessOptionTitle'}),
      value: 'biz',
    },
  ];

  return (
    <div className={styles.wrapper} id="configure-own-server">
      <MediaQuery minDeviceWidth={1224}>
        <div className={styles.hr} />
        <div className={`${styles.title} Rubik-60pt`}>
          {formatMessage({id: 'ConfigureOwn.title'})}
        </div>
        <div>
          <div className={styles['options']}>
            <div className={`${styles['option']} ${selectedPath === 'cpu' ? styles['active'] : '' }`}>
              <img className={styles['option-img']} src={CPUImg2x} alt="Start with a processor"/>
              <div className={styles['option-details']}>
                <div className={styles['option-texts']}>
                  <div className={`${styles['option-title']} Rubik-26pt`}>
                    {formatMessage({id: 'ConfigureOwn.CPUOptionTitle'})}
                  </div>
                  <div className={`${styles['option-subtitle']} Rubik-20pt`}>
                    {formatMessage({id: 'ConfigureOwn.CPUOptionSubtitle'})}
                  </div>
                </div>
                <div className={styles['option-action']}>
                  <button className={`${styles['option-action_make-selection']} Rubik-20pt`} onClick={ () => setSelectedpath('cpu') }>
                    {formatMessage({id: 'ConfigureOwn.MakeSelectionButton'})}
                  </button>
                </div>
              </div>
            </div>
            <div className={`${styles['option']} ${selectedPath === 'platform' ? styles['active'] : ''}`}>
              <img className={styles['option-img']} src={PlatformImg2x} alt="Start with a platform"/>
              <div className={styles['option-details']}>
                <div className={styles['option-texts']}>
                  <div className={`${styles['option-title']} Rubik-26pt`}>
                    {formatMessage({id: 'ConfigureOwn.PlatformOptionTitle'})}
                  </div>
                  <div className={`${styles['option-subtitle']} Rubik-20pt`}>
                    {formatMessage({id: 'ConfigureOwn.PlatformOptionSubtitle'})}
                  </div>
                </div>
                <div className={styles['option-action']}>
                  <button className={`${styles['option-action_make-selection']} Rubik-20pt`} onClick={ () => setSelectedpath('platform') }>
                    {formatMessage({id: 'ConfigureOwn.MakeSelectionButton'})}
                  </button>
                </div>
              </div>
            </div>
            <div className={`${styles['option']} ${selectedPath === 'biz' ? styles['active'] : ''}`}>
              <img className={styles['option-img']} src={BusinessImg2x} alt="Start with a biz needs"/>
              <div className={styles['option-details']}>
                <div className={styles['option-texts']}>
                  <div className={`${styles['option-title']} Rubik-26pt`}>
                    {formatMessage({id: 'ConfigureOwn.BusinessOptionTitle'})}
                  </div>
                  <div className={`${styles['option-subtitle']} Rubik-20pt`}>
                    {formatMessage({id: 'ConfigureOwn.BusinessOptionSubtitle'})}
                  </div>
                </div>
                <div className={styles['option-action']}>
                  <button className={`${styles['option-action_make-selection']} Rubik-20pt`} onClick={ () => setSelectedpath('biz') }>
                    {formatMessage({id: 'ConfigureOwn.MakeSelectionButton'})}
                  </button>
                </div>
              </div>
            </div>
            <div className={styles.option}>
              <img className={styles['option-img']} src={ExpertImg2x} alt="I am not sure at all"/>
              <div className={styles['option-details']}>
                <div className={styles['option-texts']}>
                  <div className={`${styles['option-title']} Rubik-26pt`}>
                    {formatMessage({id: 'ConfigureOwn.ExpertOptionTitle'})}
                  </div>
                  <div className={`${styles['option-subtitle']} Rubik-20pt`}>
                    {formatMessage({id: 'ConfigureOwn.ExpertOptionSubtitle'})}
                  </div>
                </div>
                <div className={styles['option-action']}>
                  <button className={`${styles['option-action_ask-an-expert']} Rubik-20pt`} onClick={() => {
                    ReactGA.set({ dimension7: ASK_AN_EXPERT_LANGING_MIDDLE });
                    showModal(RequestModal);
                  }}>
                    {formatMessage({id: 'Header.askAnExpert'})}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={1224}>
        <div className={`${styles.title} Rubik-60pt`}>
          {formatMessage({id: 'ConfigureOwn.title'})}
        </div>
        <div className={styles['dropdown-container']}>
          <Select
            options={selectOptions}
            labelField="label"
            valueField="value"
            className={`${styles.dropdown} Rubik-26pt`}
            onChange={e => setSelectedpath(e[0]?.value)}
            values={[selectOptions.find(i => i.value === selectedPath)]}
          />
          <div className={styles['dropdown-description']}>
            {selectedPath === 'cpu' && formatMessage({id: 'ConfigureOwn.CPUOptionSubtitle'})}
            {selectedPath === 'platform' && formatMessage({id: 'ConfigureOwn.PlatformOptionSubtitle'})}
            {selectedPath === 'biz' && formatMessage({id: 'ConfigureOwn.BusinessOptionSubtitle'})}
          </div>
        </div>
      </MediaQuery>
      <div className={selectedPath === 'cpu' ? '' : styles['hidden']}>
        <CpuPath showModal={showModal}/>
      </div>
      <div className={selectedPath === 'platform' ? '' : styles['hidden']}>
        <PlatformPath showModal={showModal}/>
      </div>
      <div className={selectedPath === 'biz' ? '' : styles['hidden']}>
        <BizPath showModal={showModal}/>
      </div>
    </div>
  );
};

export default ConfigureOwnScreen;
